export const MIN_AGE = 1;
export const MAX_AGE = 150;
export const ALERT_AGE = 18;
